import { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import useDeleteData from "../../../hooks/useDeleteData";
import { GetAccess } from "../../../utils/RolesandAccess";
import { SubmitButton } from "../../../utils/Button";
import useAddData from "../../../hooks/useAddData";
import { NuInput } from "../../../utils/Inputs";
import { RoleLoader } from "../../../components/Loader";
import { DeleteIcon } from "../../../assets/icons";
import UseGetData from "../../../hooks/useFetchData";

function FrequencyIndex() {
  const { data, getData, isLoading } = UseGetData({
    url: "/Frequency/",
  });
  const { isCreateLoading, addData } = useAddData();
  const { handleDelete } = useDeleteData();
  const [value, setValue] = useState({
    frequency_type: "",
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: value,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
        frequency_type: yup.string().required("Frequency Type is Required"),
    }),
    onSubmit: (value, { resetForm }) => {
      addData({
        url: "/Frequency/",
        value: value,
        resetForm: resetForm,
        onClose: ()=>{},
        getData: getData,
      });
    },
  });

  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
           Frequency
          </h4>
        </div>

        <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          {GetAccess("admin_create") && (
            <form onSubmit={formik.handleSubmit}>
              <div className="w-[60%] mx-auto flex lg:justify-center">
                <NuInput
                  formik={formik}
                  name="frequency_type"
                  label="Frequency status"
                  width="w-full"
                  placeholder="Frequency status"
                />
                <div className="flex items-center mr-8 mt-7">
                  <SubmitButton isLoading={isCreateLoading} />
                </div>
              </div>
            </form>
          )}
          <div className="w-[60%] mx-auto border border-black px-4 py-2 rounded-lg">
            {isLoading == true ? (
              <>
                <>
                  {[...Array(8)].map((_, index) => {
                    return <RoleLoader />;
                  })}
                </>
              </>
            ) : (
              <>
                {data.map((data, i) => (
                  <div className="flex justify-between my-3" key={i}>
                    <p className="text-xs py-1">{data?.frequency_type}</p>
                    {GetAccess("admin_delete") && (
                      <span
                        onClick={()=>handleDelete({
                          url: `/Frequency/${data.id}/`,
                          id: data.id,
                          value: data.frequency_type,
                          fetcher: getData,
                        })}
                      >
                        <DeleteIcon />
                      </span>
                    )}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default FrequencyIndex;
